const type = 'SET_PAYMENT_SMS_SENT';

const setPaymentSMSSent = () => ({
  type,
});

export default setPaymentSMSSent;
